import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { select, State, Store } from '@ngrx/store';
import { AppState, selectPatientId } from '@app/core/ngrx';
import { Observable } from 'rxjs';

@Component({
  selector: 'ecp-cart-header',
  templateUrl: './cart-header.component.html',
  styleUrls: ['./cart-header.component.scss'],
})
export class CartHeaderComponent implements OnInit {
  pageTitle: string;
  url: string;
  patientId: string;
  patientId$: Observable<string>;
  id;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private store: Store<AppState>,
    private state: State<AppState>,
  ) {
    this.pageTitle = activatedRoute.snapshot.data['title'];
    this.patientId$ = this.store.pipe(select(selectPatientId));
    this.patientId$.subscribe(patientId => {
      this.id = patientId;
    });
    let id = this.id;
    this.url = id ? '/' + id : '/catalog';
    this.patientId = id;
  }
  ngOnInit(): void {}
}
